import type { PreparedNewTask, Task } from './types';

type PresenceTaskField = <T extends Task>(task: PreparedNewTask<T>) => boolean;

export const hasTitle: PresenceTaskField = (task) => Boolean(task.title && task.title.trim());
export const hasDescription: PresenceTaskField = (task) => Boolean(task.description && task.description.trim());
export const hasUserFunction: PresenceTaskField = (task) => Boolean(task.userFunction);
export const hasEndDatetime: PresenceTaskField = (task) => Boolean(task.endDatetime);
export const hasStartDatetime: PresenceTaskField = (task) => Boolean(task.startDatetime);
